import React from 'react';
// import TextField from 'material-ui/TextField';
import {InputText} from '../../blocks/inputs/InputText';
import PasswordWrapper from 'modules/blocks/inputs/PasswordWrapper';
import _ from 'lodash';
import {inject} from 'mobx-react';
import {Link, withRouter} from 'react-router-dom';
import {LOGIN_USER} from 'constants/usersConstrains';
// import {containers as BaseContainers} from '../../../modules/core';
import validate from 'validate.js';
import HttpClient from 'services/HttpClient';
// import Facebook from 'modules/blocks/oauth_buttons/Facebook';
import loginImg from 'images/loginImg.png';
const LOGIN_USER_URL = '/api/v1/tokens';
// const {Footer} = BaseContainers;

@withRouter
@inject('userStore')
@inject('alertStore')
export default class extends React.Component {

    state = {
        errors: {},
        formData: {
            email: '',
            password: '',
            remember : false
        }
    };

    handleChange = e => {
        let newState = _.assign({}, this.state.formData, {[e.target.name]: e.target.value});
        this.setState({formData: newState});
    };

    handleSubmit = e => {
      e.preventDefault();
      let errors = validate(this.state.formData, LOGIN_USER, { fullMessages: false } );
      if(errors)
        this.setState({errors: errors});
      else {
        this.setState({errors: {}});
        new HttpClient().post(LOGIN_USER_URL, this.state.formData).then(data => {
          const {token, user } = data.body.data;
          this.props.userStore.loginUser(user, token);
          this.props.alertStore.success('You successfully signed in');
          // this.props.history.push('/topic/73')
          this.props.history.push('/')
        }).catch( () => {
          let newState = _.assign({}, this.state.formData, {password: ''});
          this.setState({formData: newState,
            errors: {
              email: 'The email or password you entered is incorrect',
              password: 'The email or password you entered is incorrect'}});
        });
      }
    };

    render() {
        return (
          <div className="new-form-wrapper">
            <img src={loginImg} />
            <form className="sign-in-form" onSubmit={this.handleSubmit}>
              <h2>Log In</h2>
              <InputText
                name="email"
                className='email'
                errorText={this.state.errors.email}
                value={this.state.formData.email}
                onChange={this.handleChange}
                label="Email Address"
                type="text"
                placeholder='Enter email address'
              />
              <PasswordWrapper
                value={this.state.formData.password}
                errorText={this.state.errors.password}
                name="password"
                label='Password'
                placeholder="Enter password"
                handleChange={this.handleChange}
              />
              <div className="remember-me row justify-content-between">
                <div className="input-wrap">
                  <Link className="forgot" to="/resetFormEmail">Forgot Password?</Link>
                </div>
              </div>
              <div className="button-set">
                <button className="btn-new-main" type="submit" style={{width: '100%'}}>Log In</button>
                <div className="help-label">
                  <span>Don’t have an account? </span><Link className="" to="/signUp">Create Account</Link>
                </div>
              </div>
            </form>
          </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/auth/containers/SignInForm.js